export const REGION_ORDER = [
  "Africa",
  "America",
  "Antarctica",
  "Asia",
  "Atlantic",
  "Australia",
  "Europe",
  "Indian",
  "Pacific",
  "Etc",
  "Other",
] as const;

export type Region = (typeof REGION_ORDER)[number];

export interface GroupedTimezones {
  region: Region;
  zones: string[];
}

const KNOWN_REGIONS = new Set<string>(REGION_ORDER);

export function groupTimezonesByRegion(zones: ReadonlyArray<string>): GroupedTimezones[] {
  const buckets = new Map<Region, string[]>();
  for (const region of REGION_ORDER) buckets.set(region, []);

  for (const zone of zones) {
    const slash = zone.indexOf("/");
    const head = slash === -1 ? zone : zone.slice(0, slash);
    const region: Region = (KNOWN_REGIONS.has(head) ? head : "Other") as Region;
    buckets.get(region)!.push(zone);
  }

  const result: GroupedTimezones[] = [];
  for (const region of REGION_ORDER) {
    const zonesInRegion = buckets.get(region)!;
    if (zonesInRegion.length === 0) continue;
    zonesInRegion.sort((a, b) => a.localeCompare(b));
    result.push({ region, zones: zonesInRegion });
  }
  return result;
}
